<template>
  <div class="h-100">
    <div class="h-100 d-flex flex-column" @dragover.prevent @drop.prevent="fileDropHandler" v-if="!isInvite">

      <div style="overflow-y: auto;" class="flex-grow-1" ref="scrollable-content">

        <div class="chatroom-message-section position-relative">
          <div v-if="fetchingMessages">
            <div class="text-center p-3 font-grey-gallery">Chargement des messages...</div>
          </div>

          <div v-if="chatroom.messages != undefined && chatroom.messages.length == 0 && !fetchingMessages">
            <div class="text-center p-3 font-grey-gallery">Aucun messages à afficher</div>
          </div>
          <div v-else>
            <feed-message v-for="(message, index) in reversedMessages" :key="index"
              :message="message"
              fileAttachmentImageUrl="chatroom/files/%fileid%/image"
              fileAttachmentThumbnailUrl="chatroom/files/%fileid%/thumbnail"
              fileAttachmentDownloadUrl="chatroom/files/%fileid%/download"
              @resendMessage="submitMessage($event, true)"
              @deleteMessage="deleteMessage"
            />
          </div>
        </div>

      </div>

      <div class="chatroom-compose-message">
        <div class="avatar" :style="{backgroundColor: user.user_background_color}"> {{user.user_initials}} </div>
        <div class="ml-2 flex-grow-1 position-relative">
          <fancy-textarea-box 
            ref="message-box" 
            v-model="current_message" 
            :disabled="sendingMessage" 
            @enterPressed="sendMessage" 
            @toolClick="toolClick"
          />
        </div>
      </div>

      <div class="position-absolute" style="opacity: 0; pointer-events: none">
        <input type="file" ref="message-file-upload" multiple @change="handleFileUploadFromInput">
      </div>

    </div>
    <div v-else class="h-100 d-flex align-items-center justify-content-center flex-column">
      <div style="font-size: 122px; opacity: 0.7"><i class="icon-user-follow"></i></div>
      <div>Vous avez une invitation à la conversation. Joindre la conversation?</div>
      <div class="mt-4">
        <button class="btn green-jungle" @click="acceptInvite">Accepter</button> ou
        <button class="btn red" @click="rejectInvite">Refuser</button>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from '../Select2.vue';
import FancyBox from '../FancyBox.vue'
import FancyTextareaBox from '../FancyTextareaBox.vue';
import FeedMessage from '../messagefeed/FeedMessage.vue';

export default {
  name: "chatroom-feed",
  components: { Select2, FancyBox, FancyTextareaBox, FeedMessage },
  props: {
    chatroom: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    isInvite: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      current_message: "",
      fetchingMessages: false,
      newestMessageLoaded: false,
      websocketListeningChatroomId: null,
      autoScroll: false,
      refreshCounter: 0,
      sendingMessage: false
    }
  },
  computed: {
    shortTimestamp() {
      return (date) => {
        return moment(date).format("DD MMM à HH:mm");
      }
    },
    longTimestamp() {
      return (date) => {
        return moment(date).format("DD MMM YYYY à HH:mm");
      }
    },
    isMyMessage() {
      return (message) => {
        return message.chatroom_message_user_id == this.user.user_id;
      }
    },
    reversedMessages() {
      this.refreshCounter;
      if(this.chatroom.messages === undefined){
        return [];
      } else {
        let msgs = this.chatroom.messages.slice().reverse();
        return msgs.map((msg) => ({
          sending_error: msg.sending_error,
          message_id: msg.chatroom_message_id,
          message_creation_datetime: msg.chatroom_message_creation_datetime,
          message_content: msg.chatroom_message_content,
          message_type: msg.chatroom_message_type,
          user_background_color: msg.user_background_color,
          user_initials: msg.user_initials,
          user_name: msg.user_name,
          files: (msg.files??[]).map((f) => ({
            file_id: f.chatroom_file_id,
            file_title: f.chatroom_file_title,
            file_mime: f.chatroom_file_mime
          })),
          is_mine: msg.chatroom_message_user_id == this.user.user_id,
          original: msg
        }));
      }
    },
    fileAttachmentImage() {
      return (file) => {
        return `${window.baseUrl}chatroom/files/${file.chatroom_file_id}/image`
      }
    },
    spinnerSVG() {
      return `${window.baseUrl}assets/global/img/spinner.svg`;
    },
    fileAttachmentThumbnail() {
      return (file) => {
        if(file.chatroom_file_id === null){
          return `${window.baseUrl}assets/global/img/spinner.svg`
        } else {
          return `${window.baseUrl}chatroom/files/${file.chatroom_file_id}/thumbnail`
        }
      }
    },
    isFilePdf() {
      return (file) => {
        if(file.chatroom_file_mime == null) return false;
        return file.chatroom_file_mime === "application/pdf";
      }
    },
    isFileText() {
      return (file) => {
        if(file.chatroom_file_mime == null) return false;
        return file.chatroom_file_mime.indexOf("text/") !== -1;
      }
    },
    isFileImage() {
      return (file) => {
        if(file.chatroom_file_mime == null) return false;
        return file.chatroom_file_mime.indexOf("image/") !== -1;
      }
    },
    filePreviewLink() {
      return (file) => {
        if(file.chatroom_file_id == null) return "";
        return `${window.baseUrl}chatroom/files/${file.chatroom_file_id}/download`
      }
    }
  },
  mounted () {
    moment.locale("fr");

    $(this.$refs["scrollable-content"]).on("scroll", async (e) => {
      let scrollTop = this.$refs["scrollable-content"].scrollTop;
      let scrollHeight = this.$refs["scrollable-content"].scrollHeight;
      let height = this.$refs["scrollable-content"].offsetHeight;
        
      if(!this.fetchingMessages){
        if(scrollTop <= 70) { // Charger des messages plus ancien.
          await this.fetchMessages("older");

          let diffHeight = this.$refs["scrollable-content"].scrollHeight - scrollHeight;
          if(diffHeight > 0){
            this.$refs["scrollable-content"].scrollTo({
              top: diffHeight
            })
          }

        } else if(scrollHeight - scrollTop - height <= 100) { // Charger des messages plus récent.
          await this.fetchMessages("newer");
        }
      }

      this.autoScroll = scrollHeight - scrollTop - height < 5;

    })
  },
  methods: {
    toolClick(type) {
      switch(type){
        case "send":
          this.sendMessage({
            content: this.$refs["message-box"].getAsPlainText()
          });
          break;
        case "upload":
          this.$refs["message-file-upload"].click();
          break;
      }
    },
    async handleFileUploadFromInput(ev) {
      let files = ev.target.files;
      await this.uploadFiles(files);
    },
    async acceptInvite() {
      try {
        let response = await $.post(`${window.baseUrl}chatroom/invite/accept`, { chatroom_id: this.chatroom.chatroom_id });
        this.$emit("inviteAccepted")
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'acceptation de l'invitation", err.message);
        console.error(err);
      }
    },
    async rejectInvite() {
      try {
        let response = await $.post(`${window.baseUrl}chatroom/invite/reject`, { chatroom_id: this.chatroom.chatroom_id });
        this.$emit("inviteRejected")
      } catch(err) {
        toastr.error("Une erreur s'est produite lors du refus de l'invitation");
        console.error(err);
      }
    },
    async fetchMessages(direction) {

      if(this.chatroom.messages === undefined){
        this.chatroom.messages = [];
      }

      let newestMessage = this.chatroom.messages[0];
      let oldestMessage = this.chatroom.messages[this.chatroom.messages.length-1];

      let oldestMessageIsLoaded = this.chatroom.chatroom_first_message_id == oldestMessage?.chatroom_message_id;

      let olderLimit = 10;
      let newerLimit = 10;
      let includeRef = false;

      let ref = 0;
      if(oldestMessage == null){
        ref = this.chatroom.chatroom_user_last_chatroom_message_id;

        if(ref == null) {
          olderLimit = 20;
          newerLimit = 0;
        } else {
          olderLimit = 15;
          newerLimit = 15;
        }

        includeRef = true;

      } else {
        switch(direction) {
          case "older":
            if(oldestMessageIsLoaded) return;
            ref = oldestMessage.chatroom_message_id;
            olderLimit = 20;
            newerLimit = 0;
            break;
          case "newer":
            if(this.newestMessageLoaded) return;
            ref = newestMessage.chatroom_message_id;
            olderLimit = 0;
            newerLimit = 20;
            break;
        }
      }

      this.fetchingMessages = true;

      let query = [
        `chatroomId=${this.chatroom.chatroom_id}`,
        `referenceMessageId=${ref}`,
        `olderLimit=${olderLimit}`,
        `newerLimit=${newerLimit}`,
        `includeRef=${includeRef?"1":"0"}`
      ];

      try {
        let response = await $.get(`${window.baseUrl}chatroom/messages/retrieve?${query.join('&')}`);

        if(response.data.length > 0){
          switch(direction) {
            case "older":
              this.chatroom.messages.splice(this.chatroom.messages.length, 0, ...response.data);
              break;
            case "newer":
              this.chatroom.messages.splice(0, 0, ...response.data);
              break;
            default:
              this.chatroom.messages.splice(0, this.chatroom.messages.length, ...response.data);
              break;
          }
        }

        this.newestMessageLoaded = this.newestMessageLoaded || response.newest_reached;

        window.applyAdvancedFormatDetails();

        this.updateLastReadMessage();

        this.refreshCounter++;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de l'obtention des messages");
        console.error(err);
      }

      this.fetchingMessages = false;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs["scrollable-content"].scrollTo({
          top: this.$refs["scrollable-content"].scrollHeight
        })
      })
    },
    async updateLastReadMessage() {
      if(this.chatroom.messages.length == 0) return;

      let lastMessage = this.chatroom.messages[0];

      try {
        let response = await $.post(`${window.baseUrl}chatroom/messages/updatelastread`, { chatroom_message_id: lastMessage.chatroom_message_id, chatroom_id: lastMessage.chatroom_message_chatroom_id });
        this.chatroom.chatroom_unread = !response.last_message_is_read;
        this.chatroom.chatroom_user_last_chatroom_message_id = lastMessage.chatroom_message_id;
      } catch(err) {
        toastr.error("Une erreur s'est produite.");
        console.error(err);
      }
    },
    async deleteMessage(message) {
      try {
        await $.post(`${window.baseUrl}chatroom/messages/delete`, { id: message.chatroom_message_id });
        let ix = this.chatroom.messages.findIndex(c => c.chatroom_message_id == message.chatroom_message_id);
        this.chatroom.messages.splice(ix,1);
        this.refreshCounter++;
        this.$nextTick(() => {
          window.applyAdvancedFormatDetails();
        })
        return true;
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la suppression de votre message.");
        console.error(err);
        return false;
      }
    },
    closeChatroom() {
      this.$emit("close");
    },
    sendMessage(evt) {

      let content = evt.content.trim()

      let message = {
        user_id: this.user.user_id,
        user_name: this.user.user_name,
        user_initials: this.user.user_initials,
        user_background_color: this.user.user_background_color,
        chatroom_message_content: content,
        chatroom_message_user_id: this.user.user_id,
        chatroom_message_chatroom_id: this.chatroom.chatroom_id,
        chatroom_message_type: "1"
      };

      if(message.chatroom_message_content == ""){
        return;
      }

      this.submitMessage(message);
    },
    async submitMessage(message, resend = false) {

      if(resend){
        message.sending_error = undefined;
      } else {
        this.chatroom.messages.unshift(message);
      }

      this.$nextTick(() => {
        this.$refs["scrollable-content"].scrollTo({
          top: this.$refs["scrollable-content"].scrollHeight + 200
        })

        window.applyAdvancedFormatDetails();

        this.$refs["message-box"].clear();
      })

      this.sendingMessage = true;

      try {
        let result = await $.post(`${window.baseUrl}chatroom/messages/create`, { form: message });

        let ix = this.chatroom.messages.findIndex(m => m == message);
        this.chatroom.messages.splice(ix, 1, result);
        
        window.applyAdvancedFormatDetails();
        
        this.sendingMessage = false;
        this.refreshCounter++;

      } catch(err) {
        this.sendingMessage = false;
        this.$set(message, "sending_error", "Erreur d'envoi")
        toastr.error("Une erreur s'est produite lors de l'envoi du message.");
        console.error(err);
      }

      this.$refs["message-box"].focus();
    },
    joinWebsocketRoom(){
      WS.leave(`chatrooms.message.create.${this.websocketListeningChatroomId}`);
      WS.leave(`chatrooms.message.delete.${this.websocketListeningChatroomId}`);

      this.websocketListeningChatroomId = this.chatroom.chatroom_id;

      WS.join(`chatrooms.message.create.${this.chatroom.chatroom_id}`, (data) => {
        if(data.chatroom_message != null && this.newestMessageLoaded){
          let isAutoscroll = this.autoScroll;
          this.chatroom.messages.unshift(data.chatroom_message);
          if(isAutoscroll) {
            this.$nextTick(() => {
              let scrollHeight = this.$refs["scrollable-content"].scrollHeight;
              this.$refs["scrollable-content"].scrollTo({ top: scrollHeight })
              window.applyAdvancedFormatDetails();
              this.updateLastReadMessage();
            })
          } else {
            this.$nextTick(() => {
              window.applyAdvancedFormatDetails();
              this.updateLastReadMessage();
            })
          }
          this.$emit("messageReceived", data.chatroom_message);
          this.refreshCounter++;
        }
      });
      
      WS.join(`chatrooms.message.delete.${this.chatroom.chatroom_id}`, (data) => {
        if(data.chatroom_message_id != null){
          let ix = this.chatroom.messages.findIndex(c => c.chatroom_message_id == data.chatroom_message_id);
          this.chatroom.messages.splice(ix,1);
          this.refreshCounter++;
        }
      });
    },
    fileDropHandler(ev) {
      let files = [];

      if (ev.dataTransfer.items) {
        for (var i = 0; i < ev.dataTransfer.items.length; i++) {
          if (ev.dataTransfer.items[i].kind === 'file') {
            files.push(ev.dataTransfer.items[i].getAsFile());
          }
        }
      } else {
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          files.push(ev.dataTransfer.files);
        }
      }

      if(files.length > 0){
        this.uploadFiles(files)
      }
    },
    async uploadFiles(files) {
      let chatroom_files = [];
      let chatroom_id = this.chatroom.chatroom_id;

      for (const ix in files) {
        if(ix != "length" && ix != "item"){

          (async () => {

            let message = {
              user_id: this.user.user_id,
              user_name: this.user.user_name,
              user_initials: this.user.user_initials,
              user_background_color: this.user.user_background_color,
              chatroom_message_content: "",
              chatroom_message_user_id: this.user.user_id,
              chatroom_message_chatroom_id: this.chatroom.chatroom_id,
              chatroom_message_type: "1",
              chatroom_message_id: null,
              files: [
                {
                  file: files[ix],
                  chatroom_file_id: null,
                  chatroom_file_chatroom_id: this.chatroom.chatroom_id,
                  chatroom_file_chatroom_message_id: null,
                  chatroom_file_title: files[ix].name,
                  chatroom_file_file: null,
                  chatroom_file_mime: files[ix].type,
                  chatroom_file_size: files[ix].size
                }
              ]
            };

            this.chatroom.messages.unshift(message);

            let form = Object.assign({}, message);
            delete form.files;

            let formData = new FormData();
            formData.append(`file`, files[ix]);
            formData.append(`form`, Object.serialize(form));

            try {
              let response = await $.ajax({
                url: `${window.baseUrl}chatroom/messages/createfile`,
                type: "POST",
                processData: false,
                contentType: false,
                dataType: "json",
                data: formData
              });

              let ix = this.chatroom.messages.findIndex(m => m == message);
              this.chatroom.messages.splice(ix, 1, response.message);

              toastr.success("Le fichier a été téléchargé avec succès.")
            } catch(err) {
              this.$set(message, "sending_error", "Erreur d'envoi")
              toastr.error(`Une erreur s'est produite lors du téléchargement du fichier "${message.files[0].chatroom_file_title}".`)
              console.error(err);
            }

            this.$refs["message-box"].focus();

          })();


        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.chatroom-message-section {
  .chatroom-message {
    margin-top: 10px;
    display: flex;
    padding: 0 15px;

    .content-wrapper {
      border-radius: 5px;
      background-color: rgba(0,0,0,0.1);
    }

    .my-message-actions {
      display: none;
    }

    &.my-message {
      flex-direction: row-reverse;

      &:hover .my-message-actions {
        display: block;
      }
    }

    &.sending {
      opacity: 0.7;

      .chatroom-file {
        pointer-events: none;
      }
    }

    &.error {
      opacity: 1;

      .content-wrapper {
        background-color: rgba(255, 0, 0, 0.2);
      }
    }
  }
}

.chatroom-compose-message {
  padding: 10px 15px;
  display: flex;
  align-items: top;
}

.avatar {
  border-radius: 100px;
  font-size: 18px;
  background-color: rgb(21, 89, 121);
  color: white;
  text-transform: uppercase;
  padding: 6px;
  height: 37px;
  min-width: 37px;
  width: 37px;
  text-align: center;
}

.chatroom-file {
  padding: 5px 5px;
  display: flex;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
  margin: 0 -5px;

  .chatroom-file-thumbnail {
    width: 40px;
    height: 40px;
    min-width: 40px;
    object-fit: contain;
    margin-right: 5px;
  }

  &:hover {
    background-color: #ddd;
  }
}

</style>